/**
 * Vocabulary of the `clinical-codes` mapping table: the three outcomes a
 * matched OBX can route to, and the FHIR Observation categories a row may
 * declare.
 *
 * Lives here rather than in `@agilemd/schema-version` because the CSV layer
 * (`MappingEntryCsv.ts`) needs it and `constants` carries no dependencies.
 * The zod schemas import these and re-export them, so consumers reading them
 * from `@agilemd/schema-version/schemas` keep working.
 */

export const CLINICAL_CODE_KINDS = Object.freeze({
  /** Emit a FHIR Observation. */
  OBSERVATION: 'observation',
  /** Emit a QuestionnaireResponse with one item. */
  QUESTIONNAIRE_RESPONSE: 'questionnaire-response',
  /** Drop the OBX silently — suppresses known noise codes. */
  IGNORE: 'ignore'
} as const);

export type ClinicalCodeKind = (typeof CLINICAL_CODE_KINDS)[keyof typeof CLINICAL_CODE_KINDS];

export const CLINICAL_CODE_OBSERVATION_CATEGORIES = Object.freeze([
  'vital-signs',
  'laboratory',
  'survey',
  'imaging'
] as const);

export type ClinicalCodeObservationCategory = (typeof CLINICAL_CODE_OBSERVATION_CATEGORIES)[number];
